import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ChevronDoubleRight = ({
  size,
  type,
  theme,
  className,
  dataTestId = "chevron-double-right-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.384 3.235a.667.667 0 0 0 0 .943L7.2 7.994l-3.816 3.817a.667.667 0 1 0 .943.943l4.288-4.288a.667.667 0 0 0 0-.943L4.327 3.235a.667.667 0 0 0-.943 0Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.384 3.235a.667.667 0 0 0 0 .943L11.2 7.994l-3.816 3.817a.667.667 0 1 0 .943.943l4.288-4.288a.667.667 0 0 0 0-.943L8.327 3.235a.667.667 0 0 0-.943 0Z"
    />
  </SVGIcon>
);
